// import React from "react";

// export default function Sidebar({ users, unreadCounts, selectedUsers, onSelect }) {
//   const toggleSelect = (user) => {
//     if (selectedUsers.some((u) => u.id === user.id)) {
//       onSelect(selectedUsers.filter((u) => u.id !== user.id));
//     } else {
//       onSelect([...selectedUsers, user]);
//     }
//   };

//   console.log("SSC------",users,selectedUsers);

//   return (
//     <div className="w-64 bg-gray-200 p-2 overflow-y-auto">
//       <h2 className="font-bold mb-2">Clients</h2>
//       {users.map((u) => (
//         <div
//           key={u.id}
//           className={`p-2 cursor-pointer ${
//             selectedUsers.some((sel) => sel.id === u.id)
//               ? "bg-blue-300"
//               : "bg-gray-100"
//           }`}
//           onClick={() => toggleSelect(u)}
//         >
//           {u.username}{" "}
//           {unreadCounts[u.id] > 0 && (
//             <span className="ml-2 text-sm text-red-600">
//               ({unreadCounts[u.id]})
//             </span>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// }

import {
  Badge,
  Box,
  Checkbox,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

export const Sidebar = ({ users, unreadCounts, selectedUsers, onSelect }) => {
  const [search, setSearch] = useState('');

  console.log('users', users);

  const toggleSelect = (user, isSingleSelected) => {
    if (selectedUsers.some((u) => u.id === user.id)) {
      onSelect(selectedUsers.filter((u) => u.id !== user.id));
    } else {
      if (isSingleSelected) {
        onSelect([user]);
      } else {
        onSelect([...selectedUsers, user]);
      }
    }
  };

  // // Toggle all users
  // const toggleSelectAll = () => {
  //   if (selectedUsers.length === users.length) {
  //     onSelect([]); // deselect all
  //   } else {
  //     onSelect(users); // select all
  //   }
  // };

  // Filter users based on search input
  const filteredUsers = users.filter((u) =>
    u.username.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Paper
      elevation={3}
      sx={{
        width: 280,
        bgcolor: '#f0f2f5',
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        borderRight: '1px solid #ddd',
      }}
    >
      {/* Header (fixed) */}
      {/* <Box sx={{ p: 2, borderBottom: '1px solid #ddd' }}>
        <Typography variant='h6' sx={{ fontWeight: 600 }}>
          BROADCAST ALL
        </Typography>

        <TextField
          fullWidth
          variant='outlined'
          size='small'
          placeholder='Search user...'
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mt: 1 }}
        />
      </Box> */}

      {/* Select All Checkbox */}

      {/* User list */}
      <Box sx={{ flex: 1, overflowY: 'auto', p: 2 }}>
        <Stack spacing={0.9}>

          {console.log('unreadCounts', unreadCounts)}
          {filteredUsers.map((u) => {
            const isSelected = selectedUsers.some((sel) => sel.id === u.id);
            const unread = unreadCounts[u.id] || 0;

            return (
              <Box
                key={u.id}
                onClick={() => toggleSelect(u, true)}
                sx={{
                  p: 0.1,
                  borderRadius: 2,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  bgcolor: isSelected ? '#00a884' : '#fff',
                  color: isSelected ? '#fff' : '#000',
                  transition: 'all 0.2s',
                  '&:hover': {
                    bgcolor: isSelected ? '#009977' : '#e4e4e4',
                  },
                }}
              >
                {/* Checkbox */}
                <Checkbox
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleSelect(u, false);
                  }}
                  checked={isSelected}
                  sx={{
                    color: isSelected ? '#fff' : 'default',
                    mr: 1,
                  }}
                />

              <Box sx={{display:'flex', gap:4,alignItems:'center'}}>
                  {/* Username */}
                  <Typography
                  variant='body1'
                  sx={{
                    flex: 1,
                    fontWeight: 500,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    fontSize: '0.8rem',
                  }}
                  onClick={() => toggleSelect(u, true)}
                >
                  {u?.gps_unit_name}
                </Typography>

                {/* Unread Badge */}
                {unread > 0 && (
                  <Badge
                    badgeContent={unread}
                    sx={{
                      '& .MuiBadge-badge': {
                        backgroundColor: '#d32525', // WhatsApp green
                        color: '#fff',
                        fontSize: '0.7rem',
                        minWidth: 20,
                        height: 20,
                        borderRadius: '50%',
                      },
                    }}
                  />
                )}
              </Box>
              </Box>
            );
          })}
        </Stack>
      </Box>
    </Paper>
  );
};
